import { useState } from "react";
import {
	Link,
	matchPath,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
import axios from "../api/axios";
import LoadingSpinner from "../LoadingSpinner";
import { useDispatch } from "react-redux";
import { empty_cart } from "../../state/cartSlice";
import ErrorAlert from "../ErrorAlert ";

const Cart = ({ count, price, cart, cartId }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const params = useParams();
	const dispatch = useDispatch();

	const { pathname } = useLocation();

	const history = matchPath("/cart/:rid/:tid", pathname);

	const showError = (message) => {
		setError(message);
		setTimeout(() => setError(""), 3000);
	};

	const createOrder = () => {
		setLoading(true);
		let customer = null;
		let raw_customer = localStorage.getItem("customer");
		if (raw_customer) customer = JSON.parse(raw_customer);
		axios
			.post(
				`${
					process.env.REACT_APP_API
						? process.env.REACT_APP_API
						: "http://127.0.0.1:8000/api"
				}/create-order`,
				{
					cart_key: cartId,
					order: cart,
					table: params.tid,
					customer,
					res: params.rid,
				}
			)
			.then((res) => {
				setLoading(false);
				let pOrder =
					localStorage.getItem("orders") != null
						? JSON.parse(localStorage.orders)
						: [];
				pOrder.unshift(res.data.id);
				const slicedArray = pOrder.slice(0, 10);
				localStorage.orders = JSON.stringify(slicedArray);
				dispatch(empty_cart());
				navigate(`/order-status/${params.rid}/${params.tid}`);
			})
			.catch((res) => {
				setLoading(false);
				var message = res.response.data.data;
				if ( message === undefined || message.length === 0)
				{
					message = "Something went wrong. Please clear cart and try again.";
				}	
				showError(message);
			});
	};
	if (count > 0) {
		return (
			<>
				<ErrorAlert message={error} onClose={() => setError("")} />
				{loading && <LoadingSpinner asOverlay />}
				<section className="footer">
					<div className="row bac">
						<div className="col-6 stl">
							<span className="footerst">
								{count} {count > 1 ? "items" : "item"}{" "}
							</span>
							<span className="footerst1">
								<i className="fa fa-inr"></i>
								{price}
							</span>
						</div>
						<div className="col-6 stl1">
							{history !== null ? (
								<span className="footerst1" onClick={createOrder}>
									Place Order &nbsp;<i className="fa-solid fa-caret-right"></i>
								</span>
							) : (
								<Link to={`/cart/${params.rid}/${params.tid}`}>
									<span className="footerst1">
										Next &nbsp;<i className="fa-solid fa-caret-right"></i>
									</span>
								</Link>
							)}
						</div>
					</div>
				</section>
			</>
		);
	} else {
		return <></>;
	}
};

export default Cart;
